import React from "react";
import { attributeDimensionToInt, GenericEmbedDetails, getGenericEmbed } from "../lib/embed";
import { EmbedLegacyProps } from "./EmbedLegacy.component";
import {
    CrowdSignalLegacy,
    FacebookLegacy,
    GenericResponsiveLegacy,
    GenericStaticLegacy,
    IheartRadioLegacy,
    ImgurLegacy,
    InstagramLegacy,
    SoundcloudLegacy,
    TwitterLegacy,
    YoutubeLegacy,
} from "./embeds";
import { RESPONSIVE_EMBED_MIN_WIDTH } from "./index";

interface EmbedLegacyItemProps extends EmbedLegacyProps {
    counter?: number;
}

export const EmbedLegacyItem = (props: EmbedLegacyItemProps) => {
    let { provider = "", embed_type, url } = props;
    let width: number | null = 0;
    const { attributes } = props;
    width = attributeDimensionToInt(attributes?.width);
    let details: GenericEmbedDetails = {
        provider,
        embed_type,
        url,
    };
    if (provider === "ohembed") {
        details = getGenericEmbed(props);
        if (details.provider.toLowerCase() === "facebook") {
            provider = details.provider;
            embed_type = details.embed_type;
            url = details.url;
        }
    }

    switch (provider.toLowerCase()) {
        case "facebook":
            return <FacebookLegacy {...{ ...props, ...details }} />;
        case "twitter":
            return <TwitterLegacy {...props} />;
        case "instagram":
            return <InstagramLegacy {...props} />;
        case "iheartradio":
            return <IheartRadioLegacy {...props} />;
        case "imgur":
            return <ImgurLegacy {...props} />;
        case "youtube":
            return <YoutubeLegacy {...props} />;
        case "soundcloud":
            return <SoundcloudLegacy {...props} />;
        case "crowdsignal":
            return <CrowdSignalLegacy {...props} />;
        case "streamable":
        case "ohembed":
        default:
            if ((embed_type === "rich" || embed_type === "video") && width >= RESPONSIVE_EMBED_MIN_WIDTH) {
                return <GenericResponsiveLegacy {...props} />;
            }
            return <GenericStaticLegacy {...props} />;
    }
};
